// extracted by mini-css-extract-plugin
export var card = "index-module--card--N2OcC";
export var content = "index-module--content--OM928";